(function () {
  if (window.__productSectionTour) return;
  window.__productSectionTour = true;

  function pad(index) {
    var value = String(index + 1);
    return value.length < 2 ? '0' + value : value;
  }

  function init(root) {
    if (!root || root.dataset.bound === 'true') return;
    var spots = Array.prototype.slice.call(root.querySelectorAll('[data-tour-hotspot]'));
    var list = Array.prototype.slice.call(root.querySelectorAll('[data-tour-list]'));
    var title = root.querySelector('[data-tour-title]');
    var body = root.querySelector('[data-tour-body]');
    var chip = root.querySelector('[data-tour-chip]');
    var indexEl = root.querySelector('[data-tour-index]');
    if (!spots.length || !title || !body || !chip || !indexEl) return;
    root.dataset.bound = 'true';

    function activate(index) {
      var next = (index + spots.length) % spots.length;
      spots.forEach(function (spot, spotIndex) {
        var on = spotIndex === next;
        spot.classList.toggle('is-active', on);
        if (on) {
          spot.setAttribute('aria-current', 'true');
        } else {
          spot.removeAttribute('aria-current');
        }
      });
      list.forEach(function (item, itemIndex) {
        item.classList.toggle('is-active', itemIndex === next);
      });
      var spot = spots[next];
      title.textContent = spot.dataset.title || '';
      body.textContent = spot.dataset.body || '';
      chip.textContent = spot.dataset.label || '';
      indexEl.textContent = pad(next);
      root.dataset.activeIndex = String(next);
    }

    spots.forEach(function (spot, index) {
      spot.addEventListener('click', function () {
        activate(index);
      });
    });
    list.forEach(function (item, index) {
      item.addEventListener('click', function () {
        activate(index);
      });
    });

    var prev = root.querySelector('[data-tour-prev]');
    var nextBtn = root.querySelector('[data-tour-next]');
    if (prev) {
      prev.addEventListener('click', function () {
        activate((parseInt(root.dataset.activeIndex || '0', 10) || 0) - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        activate((parseInt(root.dataset.activeIndex || '0', 10) || 0) + 1);
      });
    }
    root.dataset.activeIndex = '0';
  }

  function boot(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-product-section-tour]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
